<template>
  <div>
    <h1>Génération automatique d'un mot de passe</h1>
    <div>
      <input type="number" placeholder="8"/>

    </div>
  </div>
</template>

<script>
  export default {
    name: "GenerationMotDePasse",
    
    data() {
      return {
      }
    },
    mounted() {
      console.log("hello");
    },
    methods: {},
    computed: {}
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Admin/GenerationMotDePasse.vue